export const consumerMenuFeatureStateKey = 'consumerMenu';
